// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Photo48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Photo48: FC<Photo48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
            viewBox="0 0 48 48"
        >
            <path d="M9 42q-1.2 0-2.1-.9T6 39V9q0-1.2.9-2.1T9 6h30q1.2 0 2.1.9T42 9v30q0 1.2-.9 2.1T39 42zm0-3h30V9H9zm2.8-4.85h24.45l-7.35-9.8-6.6 8.55-4.65-6.35z" />
        </svg>
    );
};

export default Photo48;
